export default function getPositionNameByPosition( position ) {

    return position.substring(0, 3);
    
}